module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/airstrike-cancel.bcf025ff.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/airstrike-cancel.png
// module id = 3728
// module chunks = 11